<template>
    <div>
        <h2 class="title text-center mb-4">
            Daftar {{ period.title }}

            <template v-if="period.is_trial">
                (Trial)
            </template>

            <template v-else>
                Rp {{ formattedPrice }}
            </template>
        </h2>
        <signup-form @submit="submit"></signup-form>
    </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import priceFormat from '@/tools/priceFormat'
import SignupForm from '@/components/auth/SignupForm'

export default {
    components: {
        SignupForm
    },

    computed: {
        ...sync('home/*'),

        formattedPrice() {
            return priceFormat(this.period.price)
        }
    },

    methods: {
        submit() {
            let endpoint = 'auth/signup'

            let data = this.$store.get('home/signupData')

            if (this.groupName) {
                data.group_name = this.groupName
                endpoint = 'auth/groupSignup'
            }

            this.$store.dispatch('auth/signup', { data, endpoint })
                .then(() => {
                    this.$tracking.event.program.register(this.period.title)
                    this.$router.replace({ name: 'dashboard' })
                        .catch(() => {}) // Prevet uncaught error when this replace is replaced in route guard
                })
        }
    }
}
</script>
